import { connect } from 'react-redux';

import {
  FatInfrastructureList,
  IFatInfrastructureListProps,
} from '../../components/mobile/MobileFatInfrastructureList';
import { IState } from '../../store';

export function mapStateToProps(state: IState): IFatInfrastructureListProps {
  const { fatInfrastructureList } = state.villageData.village || {};

  return {
    list: fatInfrastructureList || [],
    isHidden: !state.isFatCard,
  };
}

export const MobileFatInfrastructureListContainer =
  connect<IFatInfrastructureListProps>(mapStateToProps)(FatInfrastructureList);
